export default __webpack_public_path__ + "static/times_now_semibold-webfont-e01f42ebf61f974db6598f990b4e5a01.woff";